import queryString from 'query-string';

const parseQueryString = (qs) => {
  return queryString.parse(qs);
};

export default parseQueryString;
